module.exports = __webpack_public_path__ + "img/p12.d10c377c.png";